"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackSkipLinks = exports.SkipLinksTarget = void 0;
const libs_tracking_events_1 = require("@hotelplan/libs.tracking-events");
var SkipLinksTarget;
(function (SkipLinksTarget) {
    SkipLinksTarget["SEARCH_FORM"] = "search-form";
    SkipLinksTarget["MAIN_CONTENT"] = "maincontent";
    SkipLinksTarget["FOOTER"] = "footer";
    SkipLinksTarget["CONTACT"] = "contact";
})(SkipLinksTarget || (exports.SkipLinksTarget = SkipLinksTarget = {}));
const trackSkipLinks = (target) => (0, libs_tracking_events_1.track)({
    event: `🚀 click.navigate`,
    eventMetadata: {
        source: 'skiplinks',
        target,
        component: 'header',
    },
    _clear: true,
});
exports.trackSkipLinks = trackSkipLinks;
//# sourceMappingURL=trackSkiplinks.js.map